export default __webpack_public_path__ + "static/media/0xed0bb69f9f96e8c5fffdf16c468ecec385134ea5.52c0be03.webp";